import React, { Component } from "react";
import { get as _get, isEmpty as _isEmpty } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { Navigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { withRouter } from "../../resusableComponents/hoc/withRouter";
import { requestOnboardingAccess } from "../../redux/services/user";
import { updateLoadingState } from "../../redux/actions/application";

class RequestAccess extends Component {

  constructor(props) {
    super(props);

    const { location } = props;
    const params = new URLSearchParams((location && location.search) || (typeof window !== "undefined" ? window.location.search : ""));
    const email = params.get("email") || "";
    const entraObjectId = params.get("oid") || "";
    const entraTenantId = params.get("tid") || "";
    const displayName = params.get("name") || "";
    const preferredUsername = params.get("preferredUsername") || "";

    this.state = {
      email,
      entraObjectId,
      entraTenantId,
      displayName,
      preferredUsername,
      alertSuccess: null,
      alertError: null,
      isSubmitting: false,
      redirectToLogin: false,
    };
  }

  _handleRequestAccess = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { intl, updateLoadingState } = this.props;
    const { email, entraObjectId, entraTenantId, displayName, preferredUsername } = this.state;

    if (_isEmpty(email)) { return; }

    this.setState({ isSubmitting: true, alertError: null, alertSuccess: null });

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await requestOnboardingAccess({
        email,
        entraObjectId: entraObjectId || undefined,
        entraTenantId: entraTenantId || undefined,
        displayName: displayName || undefined,
        preferredUsername: preferredUsername || undefined,
      });

      if (_get(response, "flag", false) === true) {
        const message = intl.formatMessage({
          id: "request_access.success_default",
          defaultMessage:
            "Your request for access has been submitted successfully. Our team will review it and get in touch with you shortly.",
        });

        this.setState({ alertSuccess: message, isSubmitting: false });

        // setTimeout(() => {
        //   this.setState({ redirectToLogin: true });
        // }, 8000);
      } else {
        const message =
          _get(response, "message", "") ||
          intl.formatMessage({ id: "request_access.error_default", defaultMessage: "We could not submit your request. Please try again or contact Funnel Fuel support." });

        this.setState({ alertError: message, isSubmitting: false });
      }
    } catch (err) {
      this.setState({
        alertError: intl.formatMessage({ id: "request_access.error_default", defaultMessage: "We could not submit your request. Please try again or contact Funnel Fuel support." }),
        isSubmitting: false,
      });
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  render() {
    const { intl } = this.props;
    const { email, alertSuccess, alertError, isSubmitting, redirectToLogin } = this.state;

    if (redirectToLogin) {
      return <Navigate to="/login" replace />;
    }

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "funnel.request_access", defaultMessage: "Request Access: Funnel Fuel" })}
          </title>
        </Helmet>

        <div className="login-wrapper">
          <div className="card">
            <div className="card-header">
              <img src={require("../../assets/images/logo.svg").default} className="img-logo img-fluid mx-auto d-block logo-white logo-w-200" alt="Funnel Fuel" />
            </div>

            <div className="card-body">
              <div>
                <h5 className="text-capitalize mb-3">
                  <FormattedMessage id="request_access.title" defaultMessage="Access Required" />
                </h5>
                <p className="text-grey-74 text-capitalize-first mb-6">
                  <FormattedMessage
                    id="request_access.sub_title"
                    defaultMessage="You're not registered in our system. You can request access below."
                  />
                </p>
              </div>

              {alertSuccess && (
                <div className="mb-4 text-success" role="alert">
                  <span>{alertSuccess}</span>
                  {/* <div className="mt-1 small">
                    <FormattedMessage id="request_access.redirect_notice" defaultMessage="Redirecting to login in a few seconds…" />
                  </div> */}
                </div>
              )}

              {alertError && (
                <div className="mb-4 text-danger text-capitalize-first" role="alert">
                  <span>{alertError}</span>
                </div>
              )}

              <form onSubmit={this._handleRequestAccess}>
                <div className="mb-5">
                  <label className="form-label text-capitalize" htmlFor="requestEmail">
                    <FormattedMessage id="request_access.email_label" defaultMessage="email" />
                  </label>
                  <input
                    id="requestEmail"
                    type="email"
                    className="form-control"
                    value={email}
                    disabled
                    readOnly
                  />
                </div>

                <div className="mb-5">
                  <button
                    type="submit"
                    className="btn btn-primary waves-effect w-100 text-capitalize-first"
                    disabled={_isEmpty(email) || isSubmitting || !!alertSuccess}
                  >
                    {isSubmitting ? (
                      <FormattedMessage id="request_access.requesting" defaultMessage="Requesting…" />
                    ) : (
                      <FormattedMessage id="request_access.request_button" defaultMessage="Request for access" />
                    )}
                  </button>
                </div>

                <div className="text-center">
                  <Link to="/login" className="link-grey-93 fw-medium text-capitalize-first">
                    <FormattedMessage id="request_access.back_to_login" defaultMessage="Back to login" />
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
});

export default withRouter(connect(null, mapDispatchToProps)(injectIntl(RequestAccess)));
